'use strict';

var React = require('react');
var Shape = require('../Components/Shape');
var Label = require('../Components/Label');
var Icon = require('../Components/Icon');
var _ = require('underscore');
var styleHelper = require('../../helper/styleHelper');

var CompositeIconBase = React.createClass({
  propTypes: {
    borderVisible: React.PropTypes.bool,
    labelVisible: React.PropTypes.bool,
    alarmVisible: React.PropTypes.bool
  },

  render: function () {
    var itemProps = this.initItemProps();
    var borderVisible = this.props.style !== 'ibsNone';
    var iconStyle = this.initPointStyle(itemProps.icon, 1);
    var iconBorderStyle = {};
    if (borderVisible) {
      iconBorderStyle = {
        left: itemProps.border.x,
        top: itemProps.border.y,
        width: itemProps.border.w,
        height: itemProps.border.h,
        borderColor: itemProps.border.borderColor,
        borderStyle: 'solid',
        borderWidth: itemProps.border.borderVisible?itemProps.border.thickness:0,
        boxSizing: 'border-box',
        position: 'relative',
        backgroundColor: itemProps.border.color
      };
      if (itemProps.border.shapeBorderType === 'SbEllipse') { // 圆形
        iconBorderStyle.borderRadius = '50%';
      }
      if(itemProps.border.shapeBorderType === 'SbRectangle') {  //矩形
        if (itemProps.border.radiusIsPercent) {
          var length = Math.min(itemProps.border.w, itemProps.border.h);
          length = length * itemProps.border.radius/200;
          if(itemProps.border.borderVisible){
            length = length + itemProps.border.thickness;
          }else{
            length = length + itemProps.border.thickness * 2;
          }
          iconBorderStyle.borderRadius = length;
        } else {
          iconBorderStyle.borderRadius = itemProps.border.radius;
        }
      }
    }

    //特殊处理空图标情况，使用div的border代替图标。
    var isEmpty = false;
    if ((itemProps.icon.ID || _.isEmpty(itemProps.icon.ID)) && _.isEmpty(itemProps.icon.URL) && !itemProps.icon.defaultIcon) {
      isEmpty = true;
      var borderWidth = itemProps.icon.h>64?2:1;
      var color = styleHelper.getBackgroundColor(this.props);
      var radius = parseInt(itemProps.icon.h/6, 10);
      iconStyle.border = borderWidth+'px solid '+color;
      iconStyle.borderRadius = radius+'px';
    }

    return (<div className="contents-layout">
      {
        borderVisible && <div style={iconBorderStyle}></div>
      }
      <div style={iconStyle}>
        {!isEmpty &&
          <Icon ref="icon" key="icon" {...itemProps.icon} borderVisible={false}/>
        }
      </div>
      {
        this.props.labelVisible &&
        <div style={this.initPointStyle(itemProps.label, 2)}>
          <Label ref="label" key="label" {...itemProps.label}/>
        </div>
      }
      {
        this.props.alarmVisible &&
        <div style={this.initPointStyle(itemProps.alarm, 3)}>
          <Shape ref="alarm" key="alarm" {...itemProps.alarm} textWordWrap={false}/>
        </div>
      }
    </div>);
  },

  initItemProps: function () {
    var alarm = _.extend({}, this.props.items[3]);
    var border = _.extend({}, this.props.items[0]);
    var label = _.extend({},this.props.items[2]);
    var icon = _.extend({},this.props.items[1]);
    if(this.props.currentTextColor){
      label.currentTextColor = this.props.currentTextColor;
    }else{
      delete label.currentTextColor;
    }
    if(this.props.currentColor){
      icon.currentColor = this.props.currentColor;
    }else{
      //此处颜色获取有问题，处理图标颜色应用错误的问题
      //icon.currentColor = this.props.color;
      icon.currentColor = icon.color;
    }
    var style = this.props.style;

    //不明白为何要在这里重设以下属性
    alarm.radiusIsPercent = false;
    alarm.radius = alarm.h / 2;
    alarm.textSize = alarm.textSize || 12;      //为处理告警图标中文字大小问题，做兼容处理

    if (style === 'ibsNone') {
      border.borderVisible = false;
      border.borderColor = 'transparent';
      border.color = 'transparent'
    }
    return {
      border: border,
      icon: icon,
      label: label,
      alarm: alarm
    };
  },

  initPointStyle: function (props, zIndex) {
    if (!zIndex) {
      zIndex = 0;
    }
    return {
      left: props.x,
      top: props.y,
      width: props.w,
      height: props.h,
      position: 'absolute',
      border: 'none',
      pointerEvents: 'none',
      zIndex: zIndex,
      whiteSpace: 'nowrap'
    }
  }
});

module.exports = CompositeIconBase;


// WEBPACK FOOTER //
// ./src/views/common/CompositeIconBase.jsx